<template>
  <div class="RegisterVue-wrap">
    <div class="close-box" @click="closeRegisterVue">×</div>
    <div class="RegisterVue-box">
      <h1>注册账号</h1>
      <div class="input-wrap">
        <span>邮箱</span><b>*</b><span>(接收验证码)</span>
        <div class="input-box">
          <i class="iconfont icon-email-fill"></i>
          <input
            type="text"
            v-model="email"
            placeholder="请输入邮箱"
            required
          />
        </div>
      </div>
      <div class="input-wrap">
        <span>昵称</span><b>*</b>
        <i v-if="nameSanAsFlag && name" class="red">昵称已经存在</i>
        <div class="input-box">
          <i class="iconfont icon-yonghuming"></i>
          <input type="text" v-model="name" placeholder="请输入昵称" @change="nameSanAs"/>
        </div>
      </div>
      <!-- <div class="input-wrap">
        <span>电话</span><b>*</b>
        <div class="input-box">
          <i class="iconfont icon-shouji"></i>
          <input
            type="text"
            v-model="phone"
            placeholder="请输入电话"
            required
          />
        </div>
      </div> -->
      <div class="input-wrap">
        <span>密码</span><b>*</b><i v-if="password && !validatePassword" class="red">{{ password.length < 6?'密码需要大于六位':'密码应包含数字、小写字母、大写字母和特殊字符的字符串' }}</i>
        <div class="input-box">
          <i class="iconfont icon-mima"></i>
          <input
            type="password"
            v-model="password"
            placeholder="请输入密码"
            required
          />
        </div>
      </div>
      <div class="input-wrap">
        <span>确认密码</span><b>*</b><i class="red" v-if="!sanAspaaword && repassword">两次密码不一致</i>
        <div class="input-box">
          <i class="iconfont icon-mima"></i>
          <input
            type="password"
            v-model="repassword"
            placeholder="请再次输入密码"
            required
          />
        </div>
      </div>
      
      <!-- <div class="input-wrap">
        <span>工作单位</span>
        <div class="input-box">
          <i class="iconfont icon-yonghuming"></i>
          <input type="text" v-model="company" placeholder="请输入您的工作单位" />
        </div>
      </div> -->
      <div class="input-wrap">
        <div class="input-box-2">
          <span>验证码<b>*</b></span>
          <input
            type="text"
            v-model="code"
            placeholder="请输入验证码"
            required
          />
          <span v-if="!sendFlag" @click="getCode">{{ message }}</span>
          <span class="wait-30s" v-if="sendFlag">{{ message }}</span>
        </div>
      </div>
      <div class="input-wrap-2">
            <input type="checkbox" id="successFlag" v-model="successFlag" name="successFlag" />
            <label for="successFlag">我已阅读并同意</label>
            <span class="service-message" v-for="(item,index) in serviceList" :key="index" @click="showMessage(item)">{{ item.title }}{{ index === (serviceList.length-1)?'':'、' }}</span>
        </div>
      <div class="register-button" @click="submitRegister">
        <span>确认注册</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/login";
import CryptoJS from "crypto-js";
export default {
  name: "RegisterVue",
  data() {
    return {
      email: "",
      // phone: "",
      password: "",
      repassword: "",
      name: "",
      company: "",
      code: "",
      message: "获取验证码",
      sendFlag: false,
      sendCodeInset: undefined,
      nameSanAsFlag: false,
      successFlag: false
    };
  },
  props:{
        serviceList: {
            type: Array,
            defaults() {
                return []
            },
        }
    },
  methods: {
    cryptoJSPassword(password) { 
            const SECRET_KEY = "0123456789abcdef0123456789abcdef"; // 32字节(256位)密钥
            const IV = "abcdefghijklmnop"; // 16字节IV
            const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
            const iv = CryptoJS.enc.Utf8.parse(IV);
            const encrypted = CryptoJS.AES.encrypt(
                password,
                key,
                { 
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );
            return encrypted.toString()
        },
    showMessage(item) {
            this.$emit('openMessageBoxWrap',item)
        },
    closeRegisterVue() {
      this.$emit("closeRegisterVue");
    },
    submitRegister() {
      if (!this.email) {
        this.$message({
          message: "邮箱不能为空",
          type: "warning",
        });
        return;
      }
      /**
       * if (!this.phone) {
        this.$message({
          message: "电话不能为空",
          type: "warning",
        });
        return;
      }
        */
      if (!this.password) {
        this.$message({
          message: "密码不能为空",
          type: "warning",
        });
        return;
      }
      if (!this.repassword) {
        this.$message({
          message: "确认密码不能为空",
          type: "warning",
        });
        return;
      }
      if (!this.code) {
        this.$message({
          message: "验证码不能为空",
          type: "warning",
        });
        return;
      }
      if (!this.name) {
        this.$message({
          message: "昵称不能为空",
          type: "warning",
        });
        return;
      }
      if (this.password !== this.repassword) {
        this.$message({
          message: "两次密码不一致",
          type: "warning",
        });
        return;
      }
      if(!this.validatePassword) {
        this.$message({
          message: "密码长度8-16位，需要包含数字、小写字母、大写字母和特殊字符",
          type: "warning",
        });
        return;
      }
      if(this.password.length < 8) {
        this.$message({
          message: "密码需要大于等于8位字符",
          type: "warning",
        });
        return;
      }
      console.log(this.successFlag)
      if (!this.successFlag) {
        this.$message({
          message: "请阅读并同意服务协议",
          type: "warning",
        });
        return;
      }
      // if(this.nameSanAsFlag) {
      //   this.$message({
      //     message: "昵称已存在",
      //     type: "warning",
      //   });
      //   return;
      // }
      this.goSubmit();
    },
    goSubmit() {
      api
        .goRegister({
          username: this.name,
          email: this.email,
          mobile: '0',
          password: this.cryptoJSPassword(this.password),
          name: this.name,
          workunit: this.company,
          code: this.code,
          wechat: '',
          qq: ''
        })
        .then((res) => {
          if (res.code === 0) {
            this.$message({
              message: "注册成功",
              type: "success",
            });
            this.closeRegisterVue()
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
    },
    getCode() {
      if (!this.email) {
        this.$message({
          message: "邮箱不能为空",
          type: "warning",
        });
        return;
      }
      // 验证是否为邮箱
      if (
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email)
      ) {
        this.$message({
          message: "邮箱格式不正确",
          type: "warning",
        });
        return;
      }
      this.sendFlag = true;
      let num = 60;
      this.sendCodeInset = setInterval(() => {
        num--;
        this.message = num + "秒后重新" + "获取验证码";
        if (num <= 0) {
          clearInterval(this.sendCodeInset);
          this.message = "获取验证码";
          this.sendCodeInset = undefined;
          this.sendFlag = false;
        }
      }, 1000);
      api
        .getRegisterCode({
          email: this.email,
        })
        .then((res) => {
          if (res.code === 0) {
            this.$message({
              message: "验证码已发送致邮箱[" + this.email + "]，请注意查收",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
    },
    nameSanAs() {
        // 校验名称是否已经存在
        
    }
  },
  computed: {
    validatePassword() {
  // 正则表达式匹配至少包含一个数字、一个小写字母、一个大写字母和一个特殊字符的字符串
  //       const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).+$/;
  //
  //       // 使用正则表达式的test方法检查密码是否符合要求
  //       return regex.test(this.password);
        if (this.password.length < 8 || this.password.length > 16) return false;

        // 字符类型检查
        const types = [
          /\d/.test(this.password),                    // 数字
          /[a-z]/.test(this.password),                // 小写字母
          /[A-Z]/.test(this.password),                // 大写字母
          /[^a-zA-Z0-9]/.test(this.password)          // 特殊字符
        ].filter(Boolean).length;

        return types >= 3;  // 至少3种类型
      },
      sanAspaaword() {
        if(this.password === this.repassword) {
          return true;
        }
        return false;
      },
      
  }
};
</script>

<style lang="scss" scoped>
.RegisterVue-wrap {
  position: fixed;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
  width: 500px;
  padding: 40px 45px 30px;
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  color: rgba(16, 16, 16, 1);
  font-family: "Roboto";
  z-index: 99999;
  max-height: 95%;
  overflow-y: auto;
  .close-box {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 20px;
    font-weight: bolder;
    cursor: pointer;
    &:hover {
      scale: 1.1;
    }
    &:active {
      scale: 0.9;
      color: #124fff;
    }
  }

  .RegisterVue-box {
    h1 {
      text-align: center;
      margin-bottom: 20px;
    }

    .input-wrap {
      margin-top: 10px;

      b {
        color: red;
        margin-left: 5px;
        margin-right: 5px;
        display: inline-block;
        vertical-align: sub;
      }

      i {
        font-size: 12px;
        color: #999;

        &.red {
          color: red;
        }
        &.green {
          color: green;
        }
      }

      

      span {
        font-size: 16px;
        color: #999;
      }

      .input-box {
        margin-top: 10px;
        position: relative;

        input {
          width: 100%;
          font-size: 16px;
          padding: 10px 40px;
          border: none;
          outline: none;
          background: #f5f5f5;
          border-radius: 5px;
        }

        i {
          color: #101010;
          position: absolute;
          top: 50%;
          left: 10px;
          transform: translateY(-50%);
        }
      }

      .input-box-2 {
        margin-top: 30px;
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          flex: 1;
          text-align: center;
          &:first-of-type {
            flex: 1;
          }
          &:last-of-type {
            color: #124fff;
            cursor: pointer;
            flex: 1;

            &.wait-30s {
              color: #999;
              cursor: default;
            }
          }
        }
        input {
          display: inline-block;
          font-size: 16px;
          padding: 10px 20px;
          border: none;
          outline: none;
          background: #f5f5f5;
          border-radius: 5px;
          width: 200px;
        }
      }
    }

    .register-button {
      margin-top: 20px;

      span {
        display: block;
        padding: 15px 0;
        text-align: center;
        color: #fff;
        background: #00a8ff;
        border-radius: 5px;
        cursor: pointer;
      }
    }

    .service-message {
            display: inline-block;
            margin-top: 30px;
            color: #00a8ff;
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        }
  }
}
.input-wrap-2 {
  label {
    margin-right: 5px;
  }
  input {
      vertical-align: middle;
      margin-top: -3px;
      margin-right: 5px;
  }
}
</style>